import React from 'react';
import { Container, Box } from '@hover/blueprint';
import DesktopAndTablet from './DesktopAndTablet';
import Mobile from './Mobile';

const PricingToMatch: React.FC = () => (
  <Container
    maxW="8xl"
    centerContent
    px={{ base: 400, tablet: '56px', desktop: 500 }}
    mb={{ base: 700, tablet: '80px' }}
    position="relative"
  >
    <Box
      id="pricing-to-match-each-property"
      position="absolute"
      w={0}
      h={0}
      top="30px"
    />
    <Box w="100%" maxW="1200px">
      <DesktopAndTablet />
      <Mobile />
    </Box>
  </Container>
);

export default PricingToMatch;
